import { Loading } from '@op/opds.opux';
import styles from './LoadingScreen.module.scss';

export const LoadingScreen = () => (
  <Loading data-testid='loading-screen' className={styles.spinner} />
);
